import {HelpContent} from "pages/rules/common";
import {IPasSection} from "pages/RulesPage";
import React from 'react';

interface IProps {
    item: IPasSection;
}

export const TermsTabContent: React.FC<IProps> = ({item}) => {

    return (
        <React.Fragment>
            {/* eslint-disable-next-line react/no-danger */}
            <HelpContent dangerouslySetInnerHTML={{__html: item.text}}/>
        </React.Fragment>
    );
}
